import React from 'react';

import styles from './WatchlistDelete.css';
import { useWatchlistActionsApi } from '../../Hooks/useWatchlist';

const WatchlistDelete = ({
    closeModal = () => {},
    watchlistName = '',
    watchlistUuid = ''
}) => {
    const { deleteWatchlist } = useWatchlistActionsApi();
    const deleteSelectedWatchlist = (uuid) => {
        deleteWatchlist(uuid);
        closeModal();
    };
    return (
        <div className="modal-container" data-metrics-location="PU">
            <div className="modal-content">
                <h3>Are you sure you want to delete {watchlistName}?</h3>
                <p>This action cannot be undone.</p>
            </div>
            <div className="button-row">
                <button
                    className="cancel-btn"
                    type="button"
                    onClick={() => closeModal()}
                    onKeyPress={() => closeModal()}
                >
                    Cancel
                </button>
                <button
                    className="delete-btn"
                    type="button"
                    onClick={() => deleteSelectedWatchlist(watchlistUuid)}
                    onKeyPress={() => deleteSelectedWatchlist(watchlistUuid)}
                >
                    Delete
                </button>
            </div>
            <style jsx>{styles}</style>
        </div>
    );
};

export default WatchlistDelete;
